// extracted by mini-css-extract-plugin
export default {"honeypot":"_2k+4p"};